<template>
  <div class="bread-slice">
    <div class="left">
      <span>您的位置：</span>
    </div>
    <div class="right">
      <a-breadcrumb :routes="routes">
        <!-- <a-breadcrumb-item>Home</a-breadcrumb-item>
          <a-breadcrumb-item>
            <a href>Application Center</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a href>Application List</a>
          </a-breadcrumb-item>
        <a-breadcrumb-item>An Application</a-breadcrumb-item>-->
        <template slot="itemRender" slot-scope="{route, params, routes, paths}">
          <span v-if="routes.indexOf(route) === routes.length - 1">{{route.breadcrumbName}}</span>
          <router-link v-else :to="`${basePath}/${paths.join('/')}`">{{route.breadcrumbName}}</router-link>
        </template>
      </a-breadcrumb>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Breadcrumb } from "ant-design-vue";
import Vue from "vue";
Vue.use(Breadcrumb);
export default {
  props: ["basePath", "routes"],
  data() {
    return {
      //   basePath: `/claim`,
      //   routes: [
      //     {
      //       path: "/",
      //       breadcrumbName: "保修"
      //     },
      //     {
      //       path: "/",
      //       breadcrumbName: "索赔"
      //     }
      //   ]
    };
  },
  methods: {},
  computed: { ...mapState({}) },
  components: {  }
};
</script>

<style lang='less'>
.bread-slice {
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .left {
    color: #999999;
  }

  .right {
    margin-left: 15px;
  }
}
</style>
